// The settings page's provider choice (FR-SETUP-11, FR-LLM-18).
//
// Each provider's model and effort lists sit under its radio. Changing one
// of them chooses that provider, so Test and use tests the model picked
// rather than the provider still checked. A provider that can't be chosen
// yet (its radio disabled) is left as it is. One delegated listener covers
// the fieldset. Without the bundle the server says when nothing changed.

/** Check the radio of the provider whose list just changed. */
export function chooseProvider(event: Event): void {
  const list = event.target;
  if (!(list instanceof HTMLSelectElement)) return;
  const provider = list.closest(".provider-choice .provider");
  const radio = provider?.querySelector<HTMLInputElement>(
    'input[type="radio"][name="provider"]',
  );
  if (!radio || radio.disabled || radio.checked) return;
  radio.checked = true;
}

document.addEventListener("change", chooseProvider);
